<script>
import { h, renderSlot } from 'vue'

/**
 * Display a <img src="..." title="..." alt="...">
 * If loading fails for any reason, display given slot as a fallback.
 * If not slot was provided, displays <span>{{ title }}</span> as a placeholder.
 *
 * @since KJS-6520
 */
export default {
  name: 'ExternalIconWithFallback',
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    decorative: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loadingFailed: false
    }
  },
  methods: {
    onError() {
      this.loadingFailed = true
    }
  },
  render() {
    if (this.loadingFailed) {
      return this.$slots.default
        ? renderSlot(this.$slots, 'default')
        : h('span', this.title)
    }

    return h('img', {
      src: this.src,
      title: this.title,
      alt: this.title,
      ariaHidden: this.decorative,
      onError: this.onError
    })
  }
}
</script>
